import { createContext, useContext, type ReactNode, type FC } from 'react';
import { useAuthInternal, type UseAuthReturn } from '@/hooks/auth/useAuth';

const AuthContext = createContext<UseAuthReturn | null>(null);

export const AuthProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const auth = useAuthInternal();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export function useAuth(): UseAuthReturn {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}
